// extracted by mini-css-extract-plugin
module.exports = {"container":"info_entry_container__2QXis","label":"info_entry_label__1AyPE","content":"info_entry_content__UBRxs"};